import React from 'react';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import UnknownMonoView from './Unknown';
import ImageView from './Image';
import JournalView from './Journal';
import LitView from './Literature';
import CommissionView from './Commission';
import StatusView from './Status';
import TierView from './Tier';
import { DeviationDuperbrowseContext } from '../../Duperbrowse';
const MonoView = (props)=>{
    const { deviation } = props;
    let View;
    switch(getDeviationType(deviation)){
        case DeviationTypes.IMAGE:
        case DeviationTypes.PDF:
        case DeviationTypes.FILM:
            View = ImageView;
            break;
        case DeviationTypes.STATUS:
            View = StatusView;
            break;
        case DeviationTypes.LITERATURE:
            View = LitView;
            break;
        case DeviationTypes.JOURNAL:
            View = JournalView;
            break;
        case DeviationTypes.TIER:
            View = TierView;
            break;
        case DeviationTypes.COMMISSION:
            View = CommissionView;
            break;
        default:
            View = UnknownMonoView;
    }
    if (!deviation) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(DeviationDuperbrowseContext, {
        streamId: `single-${deviation.deviationId}`,
        deviations: [
            deviation
        ]
    }, /*#__PURE__*/ React.createElement(View, props));
};
MonoView.displayName = 'MonoView';
export default MonoView;

//# sourceMappingURL=MonoView.js.map